const localeToUpperCase = languageCode => {
  const parts = languageCode.split('-');
  if (parts.length === 1) return languageCode;

  parts[1] = parts[1].toUpperCase();
  return parts.join('-');
};

export default localeToUpperCase;
